import io from "socket.io-client";
import feathers from "@feathersjs/feathers";
import socketio from "@feathersjs/socketio-client";
import auth from "@feathersjs/authentication-client";

let serverUrl = process.env.REACT_APP_SERVER_API;
let collabUrl;
let portData = process.env.REACT_APP_PORT_DATA.split(",");

/*** code to enable online (FOR ONLINE BUILD) ***/
sessionStorage.setItem("media_url", process.env.REACT_APP_ASSET_MEDIA);

/*** code to enable dynamic IP (FOR OFFLINE BUILD) ***/

// if (
//   sessionStorage.getItem("site_ip") == undefined ||
//   sessionStorage.getItem("collab_ip") == undefined ||
//   sessionStorage.getItem("port_data") == undefined
// ) {
//   var xhttp = new XMLHttpRequest();
//   xhttp.onreadystatechange = function () {
//     if (this.readyState == 4 && this.status == 200) {
//       let ips = xhttp.responseText;
//       sessionStorage.setItem(
//         "site_ip",
//         JSON.parse(ips)["REACT_APP_SERVER_API"]
//       );
//       sessionStorage.setItem("collab_ip", JSON.parse(ips)["collab_ip"]);
//       sessionStorage.setItem(
//         "port_data",
//         JSON.parse(ips)["REACT_APP_PORT_DATA"]
//       );
//       sessionStorage.setItem(
//         "media_url",
//         JSON.parse(ips)["REACT_APP_ASSET_MEDIA"]
//       );
//       sessionStorage.setItem(
//         "static_url",
//         JSON.parse(ips)["REACT_APP_STATIC_PATH"]
//       );
//     } else {
//       window.location.reload();
//     }
//   };
//   xhttp.open("GET", "js/site-config.json", true);
//   xhttp.send();
// } else {
//   //console.log("11111111",sessionStorage.getItem('site_ip'));
//   serverUrl = sessionStorage.getItem("site_ip");
//   collabUrl = sessionStorage.getItem("collab_ip");
//   portData = sessionStorage.getItem("port_data").split(",");
// }

/*** code to enable dynamic IP (FOR OFFLINE BUILD) ***/

console.log("====>>>", process.env.REACT_APP_PORTS_DATA);
let ports = portData;

/*** code to enable env IP (FOR ONLINE BUILD) ***/
let server = serverUrl + ":" + ports[Math.floor(Math.random() * ports.length)];

const socket = io(server, {
  transports: ["websocket"],
  extraHeaders: {
    "x-access-token": "YRS/DzcxC0+58jfh/kphhA6zz4Y=",
  },
});

const client = feathers();

client.configure(
  socketio(socket, {
    timeout: 2000000,
  })
);

client.configure(
  auth({
    storage: window.localStorage,
    storageKey: "feathers-jwt",
  })
);

console.log("Got a feathers-client.js!");

export default client;
